var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"captcha-container"},[_c('vue-hcaptcha',{ref:"captcha",attrs:{"sitekey":_vm.$env.VUE_APP_HCAPTCHA_SITE_KEY},on:{"verify":response => _vm.setCaptchaToken(response),"expired":() => _vm.reset(),"error":() => _vm.reset()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }